import React, { FC } from 'react';

import Box from '@material-ui/core/Box';
import cx from 'classnames';

import { NavigationItem } from '../../../../types';
import { ExpandedNavigationItem } from '../../const';
import { MenuItem } from '../MenuItem';
import useStyles from './styles';

interface MenuItemsProps {
  isMobile: boolean;
  hasSubscription: boolean;
  items?: (NavigationItem | ExpandedNavigationItem)[];
  scrolled?: boolean;
  wrapperClass?: string;
  isManager?: boolean | null;
  handleClickLink?: () => void;
}

const MenuItems: FC<MenuItemsProps> = ({
  isManager,
  isMobile,
  hasSubscription,
  items,
  scrolled = false,
  wrapperClass,
  handleClickLink,
}) => {
  const classes = useStyles(scrolled)();

  if (items?.length === 0) {
    return null;
  }

  return (
    <div className={cx(classes.wrapper, wrapperClass)}>
      {items &&
        items.map((item, i) => (
          <MenuItem
            key={item?.url}
            item={item}
            isMobile={isMobile}
            isManager={isManager}
            hasSubscription={hasSubscription}
            wrapperClass={cx(classes.menuItem, i === items.length - 1 && classes.lastMenuItem)}
            handleClickLink={handleClickLink}
          />
        ))}
      <Box className={classes.backgroundBox} />
      <Box className={classes.headerBackgroundBox} />
    </div>
  );
};

export default MenuItems;
